import { render } from "./UsersIndex.vue?vue&type=template&id=bfe2eb1e&scoped=true"
import script from "./UsersIndex.vue?vue&type=script&lang=js"
export * from "./UsersIndex.vue?vue&type=script&lang=js"

import "./UsersIndex.vue?vue&type=style&index=0&id=bfe2eb1e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe2eb1e"]])

export default __exports__